import { TUITION_EXPERIENCE_YEARS } from '@/constants/dropdownOptions';

export function getTuitionExperienceLabel(value: number | string | null | undefined): string | null {
  if (value == null || value === '') return null;

  const numericValue = Number(value);
  const matchedOption = TUITION_EXPERIENCE_YEARS.find((option) => option.value === numericValue);

  return matchedOption?.label ?? String(value);
}

export function getTuitionExperienceShortLabel(value: number | string | null | undefined): string | null {
  const label = getTuitionExperienceLabel(value);
  if (!label) return null;

  return label.replace(' years', ' yrs').replace(' year', ' yr');
}
